import { registerIcons } from "@controladad/ng-base";

// prettier-ignore
const icons = [
    'base',
    'users',
    'handheld',
    'barcode',
    'list',
    'properties',
    'location',
    'personnel',
    'assets',
    'upload',
    'report',
    'role',
    'refresh',
    'check',
    'warning',
    'error',
];

export function registerAppIcons() {
    registerIcons({
        additionalIcons: icons,
    });
}
